import createCache from '@emotion/cache';
import { EmotionCache } from '@emotion/react';

export default function createEmotionCache(): EmotionCache {
  const cache = createCache({ key: 'css' });
  cache.compat = true; // This enables compat rendering for CSR as well
  return cache;
}
